/**
 * Archived members must not appear in user/member selection dropdowns.
 */
export function isArchivedMember(member) {
  if (!member || typeof member !== "object") return false;
  if (member.archived_at || member.archivedAt) return true;
  if (member.isArchived === true || member.archived === true) return true;
  return false;
}

export function filterSelectableMembers(members) {
  if (!Array.isArray(members)) return [];
  return members.filter((member) => !isArchivedMember(member));
}
